import { firestore } from '@src/api/Firebase/Firebase';
import { collection } from 'firebase/firestore';
import { Input } from '@api/Inputs/Input';

export interface DistributionCenterInventory {
    id?: string;
    distributionCenterId: string;
    input: Input;
    stock: number;
    stockOut?: number;
}

export const DISTRIBUTION_CENTER_INVENTORY_COLLECTION = 'distribution-center-inventories';

export const distributionCenterInventoriesRef = collection(firestore, DISTRIBUTION_CENTER_INVENTORY_COLLECTION);
